import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import HomePage from '../modules/home/pages/HomePage'
import AboutPage from '../modules/about/pages/AboutPage'
import InvestorPage from '../modules/investor/pages/InvestorPage'
import PortalPage from '../modules/portal/pages/PortalPage'
import ContactPage from '../modules/contact/pages/ContactPage'
import EventsPage from '../modules/events/pages/EventsPage'
import OrderCreatePage from '../modules/orders/pages/OrderCreatePage'
import CompanionsPage from '../modules/companions/pages/CompanionsPage'
import CompanionDetailPage from '../modules/companions/pages/CompanionDetailPage'
import OrdersListPage from '../modules/orders/pages/OrdersListPage'
import OrderDetailPage from '../modules/orders/pages/OrderDetailPage'

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* 官网主要页面 */}
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/investor" element={<InvestorPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/contact" element={<ContactPage />} />
        
        {/* 功能页面（保留用于演示） */}
        <Route path="/events" element={<EventsPage />} />
        <Route path="/runners" element={<CompanionsPage />} />
        <Route path="/runner/:id" element={<CompanionDetailPage />} />
        <Route path="/orders/new" element={<OrderCreatePage />} />
        <Route path="/orders" element={<OrdersListPage />} />
        <Route path="/orders/:id" element={<OrderDetailPage />} />
        
        {/* 404重定向 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRouter
